import React, { useEffect, useState } from "react";

// Lightweight toast with smooth fade/slide using Tailwind
export default function Toast({ title = "", message, duration = 3500, onClose }) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!duration) return;
    const t = setTimeout(() => setOpen(false), duration);
    return () => clearTimeout(t);
  }, [duration]);

  // Call onClose after transition ends
  const handleTransitionEnd = () => {
    if (!open && onClose) onClose();
  };

  return (
    <div className="fixed top-4 right-4 left-4 sm:left-auto z-50 pointer-events-none">
      <div
        className={`pointer-events-auto w-full sm:w-80 max-w-full rounded-xl shadow-lg ring-1 ring-black/5 bg-white dark:bg-zinc-900 overflow-hidden transform transition-all duration-300 ease-out ${
          open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        }`}
        onTransitionEnd={handleTransitionEnd}
      >
        <div className="flex">
          <div className="w-1 bg-gradient-to-b from-indigo-500 via-sky-500 to-emerald-500" />
          <div className="flex-1 p-4">
            {title ? (
              <div className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">
                {title}
              </div>
            ) : null}
            <div className="mt-1 text-sm text-zinc-600 dark:text-zinc-300">{message}</div>
          </div>
          <button
            aria-label="Close"
            className="m-2 h-8 w-8 inline-flex items-center justify-center rounded-md text-zinc-500 hover:text-zinc-700 hover:bg-zinc-100 dark:hover:bg-zinc-800"
            onClick={() => setOpen(false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
